window.addEventListener(
    'CookiebotOnConsentReady',
    function () {
        var scriptEl = document.createElement('script');
        scriptEl.src = 'https://bot.leadoo.com/bot/dynamic.js?company=e5c4d08e';
        scriptEl.id = 'leadooScript';
        scriptEl.type = 'text/javascript';
        scriptEl.setAttribute('defer', '');

        document.body.appendChild(scriptEl);
    },
    false,
);
